// SOURCE: https://tailwindui.com/components/application-ui/navigation/steps

/* This example requires Tailwind CSS v2.0+ */
import { Icon } from '../../../subkit-ui';
import classNames from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var NavigationSteps = function NavigationSteps(_ref) {
  var steps = _ref.steps;

  var complete = function complete(step) {
    return /*#__PURE__*/_jsxs("span", {
      className: "px-6 py-4 flex items-center text-sm font-medium",
      children: [/*#__PURE__*/_jsx("span", {
        className: classNames('flex-shrink-0 w-10 h-10 flex items-center justify-center bg-subkit-primary rounded-full', {
          'group-hover:bg-indigo-800': !!step.href
        }),
        children: /*#__PURE__*/_jsx(Icon, {
          className: "text-white pt-1",
          "aria-hidden": "true",
          name: "check",
          type: "regular",
          size: "lg"
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "ml-4 text-sm font-medium text-gray-900",
        children: step.name
      })]
    });
  };

  var current = function current(step) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-subkit-primary border-solid rounded-full",
        children: /*#__PURE__*/_jsx("span", {
          className: "text-subkit-primary",
          children: step.id
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "ml-4 text-sm font-medium text-subkit-primary",
        children: step.name
      })]
    });
  };

  var upcoming = function upcoming(step) {
    return /*#__PURE__*/_jsxs("span", {
      className: "px-6 py-4 flex items-center text-sm font-medium",
      children: [/*#__PURE__*/_jsx("span", {
        className: classNames('flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 border-solid rounded-full', {
          'group-hover:border-gray-400': !!step.href
        }),
        children: /*#__PURE__*/_jsx("span", {
          className: classNames('text-gray-500', {
            'group-hover:text-gray-900': !!step.href
          }),
          children: step.id
        })
      }), /*#__PURE__*/_jsx("span", {
        className: classNames('ml-4 text-sm font-medium text-gray-500', {
          'group-hover:text-gray-900': !!step.href
        }),
        children: step.name
      })]
    });
  };

  return /*#__PURE__*/_jsx("nav", {
    "aria-label": "Progress",
    children: /*#__PURE__*/_jsx("ol", {
      role: "list",
      className: "border border-gray-300 rounded-md divide-y divide-gray-300 md:flex md:divide-y-0",
      children: steps.map(function (step, stepIdx) {
        return /*#__PURE__*/_jsxs("li", {
          className: "relative md:flex-1 md:flex",
          children: [step.status === 'complete' ? /*#__PURE__*/_jsx("a", {
            href: step.href,
            className: "group flex items-center w-full",
            children: complete(step)
          }) : step.status === 'current' ? /*#__PURE__*/_jsx(_Fragment, {
            children: step.href ? /*#__PURE__*/_jsx("a", {
              href: step.href,
              className: "px-6 py-4 flex items-center text-sm font-medium",
              "aria-current": "step",
              children: current(step)
            }) : /*#__PURE__*/_jsx("div", {
              className: "px-6 py-4 flex items-center text-sm font-medium",
              children: current(step)
            })
          }) : /*#__PURE__*/_jsx(_Fragment, {
            children: step.href ? /*#__PURE__*/_jsx("a", {
              href: step.href,
              className: "group flex items-center",
              children: upcoming(step)
            }) : /*#__PURE__*/_jsx("div", {
              className: "group flex items-center",
              children: upcoming(step)
            })
          }), stepIdx !== steps.length - 1 ? /*#__PURE__*/_jsx(_Fragment, {
            children: /*#__PURE__*/_jsx("div", {
              className: "hidden md:block absolute top-0 right-0 h-full w-5",
              "aria-hidden": "true",
              children: /*#__PURE__*/_jsx("svg", {
                className: "h-full w-full text-gray-300",
                viewBox: "0 0 22 80",
                fill: "none",
                preserveAspectRatio: "none",
                children: /*#__PURE__*/_jsx("path", {
                  d: "M0 -2L20 40L0 82",
                  vectorEffect: "non-scaling-stroke",
                  stroke: "currentcolor",
                  strokeLinejoin: "round"
                })
              })
            })
          }) : null]
        }, step.name);
      })
    })
  });
};